import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tNotifications\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_6 = { class: "x_panel" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NotificationHistoryVue = _resolveComponent("NotificationHistoryVue");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_NotificationHistoryVue, { showSummary: true })
                    ])
                ])
            ])
        ])
    ]));
}
